import "./QuickActionsButton.css";

import { EllipsisDarkIcon } from "../../../assets";
import { Button } from "../../forms";
import { ProfileMenu, ProfileMenuItem, ProfileMenuItemType } from "../../navigation";

interface QuickActionsButtonProps {
  options: ProfileMenuItemType[];
  showMenu: boolean;
  setShowMenu: (show: boolean) => void;
}

/** "Quick actions" button opening a menu of actions; renders nothing when there are no options. */
export const QuickActionsButton = ({ options, showMenu, setShowMenu }: QuickActionsButtonProps): JSX.Element | null => {
  if (options.length === 0) return null;

  return (
    <div>
      <Button
        text="Quick actions"
        variant="tertiary"
        size="smallLarge"
        corners="rounded"
        icon={<EllipsisDarkIcon />}
        className="QuickActionsButton"
        minWidth={false}
        onClick={() => setShowMenu(true)}
      />
      <ProfileMenu show={showMenu} onClose={() => setShowMenu(false)} position={{ top: "0" }}>
        {options.map((option) => (
          <ProfileMenuItem
            key={option.id}
            profileMenuItem={option}
            onClick={() => {
              if (option.action) {
                option.action();
              }
              setShowMenu(false);
            }}
          />
        ))}
      </ProfileMenu>
    </div>
  );
};
